<template>
  <div>
    <div class="tTitle mt30">单元目标</div>
    <div class="imgContent">
      <div
        v-for="(desc,index) in unitImg"
        :key="index"
      >
        <div
          class="pb30"
          v-if="desc.text!=undefined"
          v-html="desc.text"
        ></div>
        <div
          class="pb30"
          v-if="desc.smallPath!=undefined"
        >
          <img
            :src="contentHost+desc.smallPath"
            @click="viewPhoto(index)"
          />
        </div>
      </div>
    </div>
    <div class="banner">
      <img :src="require('@/assets/images/machine.png')" />
    </div>
    <div class="zixun">进一步了解详情，请咨询教育顾问</div>
    <div
      class="btnTop"
      @click="jumpTop"
      v-if="backTopShow"
    ></div>
  </div>
</template>

<script>
import paramsHelper from '@/assets/js/parametersHelper'
export default {
    name: 'Target',
    data () {
        return {
            backTopShow: false,
            contentHost: '',
            unitImg: [],
            msg: '网络数据请求异常',
            imgShow: false,
            imgIndex: 0,
            pos: 0,
            images: []
        }
    },
    created () {

    },
    mounted () {
        var that = this;  
        var unitObj = JSON.parse(sessionStorage.c_contentContents);
        that.contentHost = sessionStorage.c_host;
        var host = sessionStorage.c_host;
        var pos = parseInt(this.$route.query.pos);
        that.pos = pos;
        var unit = unitObj[pos];
        that.unitImg = unit;
        var imgurls = [];
        for (var i = 0, len = unit.length; i < len; i++) {
            var path = unit[i].path;
            if (path != undefined) {
                var imgurl = host + path;
                imgurls.push(imgurl);
            }
        }
        that.images = imgurls;
    },
    computed: {

    },
    methods: {
        jumpTop: function () {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        // viewMachine: function () {
        //     window.location.href = 'https://www.youxuepai.com/market/sync_experience_type/index.html#/home';
        // },
        changeImg: function (index) {
            this.imgIndex = index;
        },
        viewPhoto: function (index) {
            // var that = this;
            // vant.ImagePreview({
            //     images: that.images,
            //     startPosition: index,
            //     onClose () {
            //         // do something
            //     }
            // });
        }
    }
}

</script>

<style scope lang="less">
</style>
